module.exports = __webpack_public_path__ + "img/blue_094.e175dfaa.png";